export const BaseUrl = `stage.systemqp.pro`;
